<script>
export default {
  computed: {
    forgotPassword() {
      return () => import(`@/components/Themes/${this.$cookies.get('theme') ?? 'default'}/ForgotPassword`);
    }
  },
  methods: {},
};
</script>
<template>
  <component :is="forgotPassword" v-if="forgotPassword"></component>
</template>